module.exports = __webpack_public_path__ + "f5f2566b93e89391da4db79462b8078b.woff2";